import { render, staticRenderFns } from "./EventsReport.vue?vue&type=template&id=0bf8e619&scoped=true"
import script from "./EventsReport.vue?vue&type=script&lang=js"
export * from "./EventsReport.vue?vue&type=script&lang=js"
import style0 from "./EventsReport.vue?vue&type=style&index=0&id=0bf8e619&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8e619",
  null
  
)

export default component.exports